import type { ReactNode } from 'react'
import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'

import type { RootState } from 'reduxStore'

import { hideLoadingScreen } from './app'
import ErrorPage from './ErrorPage'
import LoginPage from './LoginPage'

interface ErrorBoundaryProps {
  children: ReactNode
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({ children }) => {
  const appError = useSelector((state: RootState) => state.app.error)
  const isUserAuthenticated = useSelector((state: RootState) => state.app.isUserAuthenticated)

  // The loading screen is loaded in the DOM before the config is loaded, so we need to hide it when authentication fails or there is an API error
  useEffect(() => {
    if (!isUserAuthenticated || appError) {
      hideLoadingScreen(0) // Hide immediately, no transition
    }
  }, [isUserAuthenticated, appError])

  // If not authenticated, show login page
  if (!isUserAuthenticated) {
    return (
      <LoginPage />
    )
  }

  // If there is an API error, show the error page
  if (appError) {
    return (
      <ErrorPage />
    )
  }

  // No errors, render children (PoziApp)
  return <>{children}</>
}

export default ErrorBoundary
